module.exports = __webpack_public_path__ + "static/media/slide21_image.d3b443af.png";